<template>
  <el-popover
    v-model="show"
    placement="bottom-start"
    width="170"
    trigger="manual"
    popper-class="phone-card-popper"
  >
    <div class="phone-card-wrapper">
      <p class="phone-btn"><i class="icon-outline_phone"></i></p>
      <div class="right-box">
        <p class="phone-title">{{title}}</p>
        <p class="phone-num">{{phone}}</p>
      </div>
    </div>
    <slot slot="reference" />
  </el-popover>
</template>
<script>
export default {
  name: 'PhoneCard',
  props: {
    show: Boolean,
    title: String,
    phone: String,
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
.phone-card-popper {
  padding: 12px 12px;
  border: none !important;
  .popper__arrow {
    border: none;
  }
}
</style>
<style lang="scss" scoped>
.phone-card-wrapper {
  overflow: hidden;
}
.phone-btn {
  display: inline-block;
  margin-right: 12px;
  padding: 4px 0;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  font-size: 24px;
  color: #000;
  vertical-align: middle;
}
.right-box {
  display: inline-block;
  width: 108px;
  vertical-align: middle;
}
.phone-title {
  height: 18px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 14px;
  color: #000000;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  word-wrap: break-word;
}
.phone-num {
  margin-top: 2px;
  height: 16px;
  line-height: 16px;
  font-family: 'Aspira Light';
  font-weight: 200;
  font-size: 12px;
  color: #000000;
}
</style>